import React, { useState } from "react";
import { Row, Col, Form, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Avatar from "../../../assets/img/default.jpg";
import Select from 'react-select'
const teamcategory = [
    { value: '1', label: 'NFL', isFixed: false },
    { value: '2', label: 'Baltimore Ravens', isFixed: false },
    { value: '3', label: 'Atlanta Falcons', isFixed: false },
    { value: '4', label: 'Buffalo Bills', isFixed: false },
    { value: '5', label: 'Carolina Panthers', isFixed: false },
    { value: '6', label: 'Cincinnati Bengals', isFixed: false },
    { value: '7', label: 'Jacksonville Jaguars', isFixed: false },
    { value: '8', label: 'Kansas City Chiefs', isFixed: false },
    { value: '9', label: 'Chicago Bears', isFixed: false },
    { value: '10', label: 'Cleveland Browns', isFixed: false },
  ]
  const teamOptions = values => {
    if (values.length > 0) return values.filter(v => v.isFixed).concat(values.filter(v => !v.isFixed))
  }
export default function Adduser() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [Username, setUsername] = useState('');
    const [status, setStatus] = useState('select'); 
    const [fixedValue, setFixedValue] = useState('')
    const fixedOnChange = (value, { action, removedValue }) => {
      switch (action) {
        case 'remove-value':
        case 'pop-value':
          if (removedValue.isFixed) {
            return
          }
          break
        case 'clear':
          value = teamcategory.filter(v => v.isFixed)
          break
        default:
          break
      }
  
      value = teamOptions(value)
      setFixedValue(value)
    }
    const customStyles = {
        control: (provided, state) => ({
          ...provided,
          border: state.isFocused ? '1px solid #DADADA' : '1px solid #DADADA',
          boxShadow: 'none',
          minHeight: '52px',
          fontSize: '14px',
          borderRadius: '8px',
          '&:hover': {
            border: '1px solid #DADADA', // Slightly darker border on hover
            },
        }),
        multiValue: (provided, state) => ({
            ...provided,
            color: '#fff',
            backgroundColor: '#044719', // Change background color of the selected value container
          }),
        multiValueLabel: (provided, state) => ({
            ...provided,
            color: '#fff',
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            display: 'none', // Hides the separator
          }),        
      };    
    return (
        <React.Fragment>
            <Card>
                <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
                    <h5>Add User</h5>
                    <Link className="btn btn-primary2 d-inline-flex align-items-center justify-content-center px-4 min_width140" to="/users">Back</Link>
                </Card.Header>
                <Card.Body>
                    <Row className="mt-3">
                        <Col md={5} xl={4} className="view_profile mb-3 ">
                            <div className="user_info text-center">
                                <div className="d-flex align-items-center justify-content-center">
                                    <img src={Avatar} className="rounded-circle img-fluid profilepic" alt="" />
                                </div>
                                <label htmlFor="uploadprofileimg" className="d-inline-block mt_30 btn btn-primary-outline px-4 font-size-14 lh-40">Choose Picture</label>
                                <input type="file" id="uploadprofileimg" className="d-none" />
                            </div>
                        </Col>
                        <Col md={7} xl={8}>
                            <Form>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="form-group mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter name" value={name} onChange={(e) => setName(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="form-group mb-3">
                                            <Form.Label>Email Address</Form.Label>
                                            <Form.Control type="email" placeholder="Enter email address" value={email} onChange={(e) => setEmail(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="form-group mb-3">
                                            <Form.Label>Username</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Username" value={Username} onChange={(e) => setUsername(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="form-group mb-3">
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)} >
                                                <option value="select">Select Status</option>
                                                <option value="1">Active</option>
                                                <option value="2">Inactive</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="form-group mb-3">
                                            <Form.Label>Teams</Form.Label>
                                            <Select
                                                isClearable={false}
                                                value={fixedValue}
                                                isMulti
                                                name='colors'
                                                styles={customStyles}
                                                options={teamcategory}
                                                onChange={fixedOnChange}
                                                className='multiselect'
                                                classNamePrefix='select'
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Button className="btn btn-primary px-4 mt-3 min_width140">Save</Button>
                            </Form>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        </React.Fragment>
    )
}